const reassurances = [
  {
    icon: 'ri-file-list-3-line',
    title: 'Devis gratuit',
    desc: 'Sans engagement, transparent',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Garantie 10 ans',
    desc: 'Sur toutes nos réparations',
  },
  {
    icon: 'ri-timer-flash-line',
    title: 'Intervention 24-48h',
    desc: 'Rapide, sur Lyon et métropole',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '7j/7',
    desc: 'Intervention tous les jours, 7h-21h',
  },
];

export default function ReassuranceBar() {
  return (
    <div className="bg-primary-500">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {reassurances.map((item, idx) => (
            <div key={idx} className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-md bg-accent-500/20 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-accent-400 text-lg w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <div>
                <p className="font-heading font-semibold text-sm text-background-50 whitespace-nowrap">{item.title}</p>
                <p className="text-xs text-primary-200 mt-0.5">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}